import styled from 'styled-components';
import IcoW01 from 'dc/IcoW01';
import { Typ50, Typ40 } from 'dc/Typ';
import Mod001 from 'dc/Mod001';
import SeF001 from 'dc/Sef001';

export const Modal = styled(Mod001)`
  width: 646px;
  > div {
    border-radius: 5px;
    box-shadow:
      0 15px 20px rgba(0, 0, 0, 0.22),
      0 19px 60px rgba(0, 0, 0, 0.3);
    max-width: 646px;
    width: 100%;
  }
  @media only screen and (max-width: 600px) {
    width: 100%;
    height: 100vh;
    > div {
      border-radius: 0;
      box-shadow: unset;
      max-height: unset;
      margin: 0;
    }
  }
`;

export const CloseIconContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const CloseIcon = styled(IcoW01)`
  cursor: pointer;
  color: #607d8b;
  &:hover {
    color: #263238;
  }
`;

export const InnerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  background-color: transparent;
  padding: 0 40px;
  @media only screen and (max-width: 600px) {
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 288px;
  height: 517px;
  margin-right: 32px;
  padding-top: 52px;
  @media only screen and (max-width: 600px) {
    margin-right: 0;
    width: 100%;
    padding-top: 0;
    height: unset;
  }
`;

export const Heading = styled(Typ50)`
  width: 100%;
  margin-bottom: 8px;
  color: #263238;
`;

export const SubHeading = styled(Typ40)`
  color: ${props => (props.color ? props.color : '#689F38')};
  margin-bottom: 24px;
`;

export const Text = styled(Typ40)`
  color: #607d8b;
  margin-bottom: 45px;
  @media only screen and (max-width: 600px) {
    margin-bottom: 60px;
    font-size: 14px;
    line-height: 20px;
  }
`;

type ImageProps = {
  src?: string;
};

export const Image = styled.div<ImageProps>`
  width: 246px;
  height: 391px;
  background: ${props => (props.src ? `url(${props.src})` : 'none')};
  background-repeat: no-repeat;
  background-size: cover;
  @media only screen and (max-width: 600px) {
    height: 350px;
  }
`;

export const Footer = styled(SeF001)``;
